import { render, staticRenderFns } from "./AssignmentActions.vue?vue&type=template&id=0ee92b5c"
import script from "./AssignmentActions.vue?vue&type=script&lang=js"
export * from "./AssignmentActions.vue?vue&type=script&lang=js"
import style0 from "./AssignmentActions.vue?vue&type=style&index=0&id=0ee92b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports